import {BaseEntity} from "../common/base-entity";
import {ReferralForm} from "./referral-form";
import {Address} from "../shared/address";
import {AddressTypes} from "../shared/address-types";
import {MatterType} from '../common/model/matter-type';
import {FormArray, FormControl, FormGroup} from "rx-form-mapper";
import {ReferralDocument} from "./referral-document";
import {ReferredClient} from "./referred-client";

export type referralStatusType =  'DRAFT' | 'SUBMITTED' | 'ACCEPTED' | 'DECLINED';

export class Referral extends BaseEntity {

    @FormControl()
    id: number;
    @FormControl()
    status: referralStatusType;
    formData : string;
    @FormGroup()
    referralForm : ReferralForm;
    targetCustomerAccountId: number;
    targetLawyerId : number;
    lawFirm: string;
    propertyAddress: string;
    matterType: MatterType;
    matterTypeName: string;
    lastUpdatedTimeStamp : number;
    @FormArray(ReferralDocument)
    documents: ReferralDocument[] = [];
    property : string;
    client : string;
    submittedOn : number;
    assignedMatterId: number;
    matterAddressOrDescription: string;
    matterCloseDate: string;
    // UI only - Flag will be true in case the referral created by a Unity Connect User is added as Participant in Matter
    referralAddedAsParticipant: boolean;

    constructor(referral?: Referral) {
        super(referral);
        if (referral) {
            if(referral.formData){
                this.referralForm = new ReferralForm(JSON.parse(referral.formData));
            }
            this.documents = [];
            if(Array.isArray(referral.documents)) {
                for(let cc of referral.documents) {
                    this.documents.push(new ReferralDocument(cc));
                }
            }
        }

    }

    cleanUpReferral() : void {
        this.formData =  JSON.stringify(this.referralForm);
        this.targetCustomerAccountId =  this.referralForm.receivingLawFirmId;
        this.targetLawyerId =  this.referralForm.receivingSolicitorId;
        if(this.referralForm.propertyAddress){
            this.property = new Address(this.referralForm.propertyAddress).fullAddress;
        }
        this.submittedOn = this.referralForm.submissionDate;
        if (Array.isArray(this.referralForm.referredClients) && this.referralForm.referredClients.length > 0){
            this.client = this.referralForm.referredClients.filter(item => !!item.fullName && item.fullName != "").map( (rc: ReferredClient) => { return rc.fullName; }).join(';');
        } else{
            this.client = '';
        }



    }

    isDraft() : boolean {
        return this.status == 'DRAFT';
    }

    isSubmitted() : boolean {
        return this.status == 'SUBMITTED';
    }

    isAccepted() : boolean {
        return this.status == 'ACCEPTED';
    }

    isDeclined() : boolean {
        return this.status == 'DECLINED';
    }


}

